import { executeApiCall } from 'services/api';
import { getMutations } from 'entities/hooks/mutation';

import { serviceMutations } from './services';

import { SuccessData } from 'types/api';
import { Team } from '../types';
import { pick } from 'utils/object';
import { teamTagsMutations } from './tags';

const updateProperties: (keyof Team)[] = [
  'id',
  'name',
  'reprice',
  'outsourcing',
  'taskManagement',
  'addTaskSubOwner',
  'hasServices',
  'salesArea',
  'canAssumeTasksFromOtherAreas',
  'canAssumeProject',
  'canRequestTaskReasignement',
  'canSetDeadlines',
  'canChangePrices',
  'isProjectOwner',
  'canCreateProject',
  'canEnableProjectToStart',
  'canApproveCountryAddition',
  'isInvoiceTeam',
  'isRecruitmentTeam',
  'clientsPageAccess',
];

const baseTeamMutations = getMutations({
  createTeam: {
    action: async (payload: Omit<Team, 'id'>): Promise<SuccessData> => {
      return executeApiCall({
        path: '/teams',
        payload,
      });
    },

    messages: {
      success: 'team-created-with-success',

      error: 'error-while-creating-team',
    },

    validate: (payload: Omit<Team, 'id'>) => {
      return {
        ok: !!payload.name,
      };
    },
  },

  updateTeam: {
    action: async (payload: Partial<Team>): Promise<Team> => {
      return executeApiCall({
        path: '/teams',
        method: 'put',
        payload: pick(payload, updateProperties),
      });
    },

    messages: {
      error: 'error-while-updating-team',
      success: 'team-updated-with-success',
    },
  },
});

export const teamMutations = {
  ...baseTeamMutations,

  ...serviceMutations,

  ...teamTagsMutations,
};

export type { FormTeamService } from './services';
